import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'get-prompt-competitor-citations' as const;

const argumentZod = z.object({
  domains: z
    .array(z.string())
    .min(1)
    .describe(
      'Array of the site\'s own domain URLs (e.g. ["https://example.com"])'
    ),
  competitorDomains: z
    .array(z.string())
    .min(1)
    .describe(
      'Array of competitor domain URLs (e.g. ["https://competitor.com"])'
    ),
  start: z
    .string()
    .describe('Start date in ISO 8601 format (e.g. "2025-01-01T00:00:00Z")'),
  end: z
    .string()
    .describe('End date in ISO 8601 format (e.g. "2025-01-31T23:59:59Z")'),
  topicId: z.string().optional().describe('Optional topic ID to filter by'),
  platformId: z
    .string()
    .optional()
    .describe('Optional platform ID to filter by'),
  limit: z
    .number()
    .int()
    .positive()
    .optional()
    .describe('Optional limit on the number of rows returned'),
});

export const getPromptCompetitorCitationsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get prompt competitor citations',
  family: 'brand',
  llmTool: {
    name: toolName,
    description:
      'Gets competitor citation data for the current site (from MCP session context). Returns citation rows with resolved topic names and prompt text, showing which competitors are being cited by AI answer engines for the given domains and time range.',
    inputSchema: argumentZod,
  },
  type: 'server',
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetPromptCompetitorCitationsArgumentType = z.infer<
  typeof argumentZod
>;
